import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    ${props => props.theme.colors.surface} 25%,
    ${props => props.theme.colors.hover} 37%,
    ${props => props.theme.colors.surface} 63%
  );
  background-size: 400% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
  border-radius: ${props => props.theme.borderRadius.small};
  display: inline-block;
`;

const SkeletonText = styled(SkeletonBase)`
  height: ${props => props.height || '16px'};
  width: ${props => props.width || '100%'};
  margin-bottom: ${props => props.marginBottom || '8px'};
`;

const SkeletonCard = styled(SkeletonBase)`
  height: ${props => props.height || '200px'};
  width: ${props => props.width || '100%'};
  border-radius: ${props => props.theme.borderRadius.medium};
`;

const SkeletonAvatar = styled(SkeletonBase)`
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
  border-radius: 50%;
`;

const SkeletonButton = styled(SkeletonBase)`
  height: 36px;
  width: ${props => props.width || '120px'};
  border-radius: ${props => props.theme.borderRadius.small};
`;

// Compound skeleton components
export const TextSkeleton = ({ lines = 3, ...props }) => (
  <div>
    {Array.from({ length: lines }, (_, index) => (
      <SkeletonText
        key={index}
        width={index === lines - 1 ? '60%' : '100%'}
        {...props}
      />
    ))}
  </div>
);

export const CardSkeleton = (props) => <SkeletonCard {...props} />;

export const AvatarSkeleton = (props) => <SkeletonAvatar {...props} />;

export const ButtonSkeleton = (props) => <SkeletonButton {...props} />;

export const Skeleton = {
  Text: TextSkeleton,
  Card: CardSkeleton,
  Avatar: AvatarSkeleton,
  Button: ButtonSkeleton,
};